import { combineReducers, configureStore } from '@reduxjs/toolkit';
import { priceService } from "~/store/price/price-service";
import { featuresModuleService } from '~/store/report-features/features-module-service'
import countryReducer from './reducers/CountrySlice';

const rootReducer = combineReducers( {
  [priceService.reducerPath]: priceService.reducer,
  [featuresModuleService.reducerPath]: featuresModuleService.reducer,
  countryReducer
})

export const setupStore = () => {
  return configureStore( {
    reducer: rootReducer,
    middleware: getDefaultMiddleware =>
      getDefaultMiddleware().concat([priceService.middleware, featuresModuleService.middleware])
  })
}

export type RootState = ReturnType<typeof rootReducer>
export type AppStore = ReturnType<typeof setupStore>
export type AppDispatch = AppStore['dispatch']
